import React from "react";
import { GlobalContext } from '../Context/GlobalContext';
import { Redirect } from 'react-router-dom';
import axios from "axios";

import Document from "./Document";
import Agenda from "./Agenda";
import Checkout from "./Modals/Stripe/Checkout";
import SelectOption from "./NewFuncComponents/Modals/SelectOption";
import Schedule from "./Schedule/Schedule";
import ShareButton from './Buttons/ShareButton';

import VideoPlayWrapper from "./NewFuncComponents/VideoPlayWrapper";
import RecommendedVideosList from "./NewFuncComponents/RecommendedVideosList.js";
// import Recomended from "./Recomended";
import Comment from "./Helpers/Comment";

import ProfilePic from "./Layout/ProfilePic";

import { parse, parseNumbers, parseText, parseSchedule } from "../Helpers/parse";
import {getQueryVariable} from "Helpers/QueryString";
import copy from "copy-to-clipboard";
import * as crypto from "crypto-js";


const VIDEO_UPDATE_URL = "https://rkpf1ewcje.execute-api.us-west-2.amazonaws.com/";

const VIDEO_LOOKUP_URL = "https://3bljoanbf4.execute-api.us-west-2.amazonaws.com/";

const VIEWS_URL = "https://m513nl9tlc.execute-api.us-west-2.amazonaws.com/";

const DOCS_URL = 'https://y36ghvjzf4.execute-api.us-east-1.amazonaws.com/api';
// const DOCS_URL = 'http://localhost:8081';

class VideoScreen extends React.Component {
  static contextType = GlobalContext;
  state = {
    documents: [],
    file: {
      metadata: {},
      agenda: [],
      // likes: [],
      // dislikes: [],
      comments: [],
      views: [],
      // liked: false,
      // disliked: false,
      shared: false,
      watchTime: 0,
      file: { metadata: { duration: 30 } },
      documentDisplay: false,
      videoStyle: { maxWidth: '100%' },
    },
    checkout: false,
    _watchToken: crypto.lib.WordArray.random(256).words.join(""),
    liveURL: "https://ak0i1ibny3.execute-api.us-west-2.amazonaws.com/default",
    playNext: false,
    shouldUpdate: false,
    scrubTo: 0,
    currentTime: 0,
    watchToken: null,
    schedule: [],
    schedule_info: {},
    schedule_metadata: {},
    lastViewUpdate: 0,
    liveViewCount: 0,
    itemBeingBought: '',
    hideVideoViews : false,
    redirect: false,
    hasDocsAndAgendas: false,
    popup:false,
    docsAgendasDisplay: 'agenda'
  };
  mounted = true;
  updateLiveViewsTimeout = null;


  componentDidMount() {
    window.scrollTo(0, 0);
    const validChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+{}:";
    
    let array = new Uint8Array(256);
    window.crypto.getRandomValues(array);
    array = array.map((x) => validChars.charCodeAt(x % validChars.length));
    const randomState = String.fromCharCode.apply(null, array);

    this.setState({
      id: this.props.video,
      _id: this.props.pub_user ? this.props.pub_user._id : "",
      watchToken: randomState,
    });

    if (getQueryVariable("type") === "live") {
      this.startLive();
      this.updateLiveViews();
      this.getSchedule();
      axios.get(`https://9efovgrib0.execute-api.us-west-2.amazonaws.com/${this.props.video}?type=live`)
      .then(res => {
        if (this.mounted && res.data) {
          this.startLive();
          this.updateLiveViews();
          this.setState({
            file: res.data,
            // liked:
            //   this.props.pub_user &&
            //   res.data.likes.includes(this.props.pub_user._id),
            // disliked:
            //   this.props.pub_user &&
            //   res.data.dislikes.includes(this.props.pub_user._id),
            shared: false,
          });
          if (!this.state.schedule.length) {
            this.getSchedule(res.data.url)
          }
        }
      });
    } 
    else {
      
      axios.post(`${this.props.url}/upload/info`, { file: this.props.video } )
      .then(res => {
        let file = res.data.response.payload.file;

        if (
          this.props.pub_user &&
          file.downloadBuys &&
          file.downloadBuys.includes(this.props.pub_user._id)
        ) {
          file.downloadPrice = 0;
        }
        if (this.mounted) {
          const temp_hideVideoViews = res.data.response.payload?.file?.switches?.hideViews?.selected
          this.setState({
            file,
            // liked:
            //   this.props.pub_user &&
            //   res.data.response.payload.file.likes.includes(
            //     this.props.pub_user._id
            //   ),
            // disliked:
            //   this.props.pub_user &&
            //   res.data.response.payload.file.dislikes.includes(
            //     this.props.pub_user._id
            //   ),
            shared: false,
            hideVideoViews : temp_hideVideoViews && temp_hideVideoViews == 'enabled' ? true : false
          });
        }

        axios.post(`${DOCS_URL}/file-documents`,
          { user: this.props.user, file: file._id }
        )
        .then(res => {
          if(res.status === 200) {
            this.setState(state => ({...state, documents: res.data }));

            // if (this.state.documents.length > 0) {
            //   this.setState({ 
            //     ...this.state,
            //     documentDisplay: true,
            //     docsAgendasDisplay: 'agenda',
            //     videoStyle: { width: '100%' }
            //   });
            // }
            // If documents and agendas exist, we put in a tab system to swap
            // between indexes and documents.
            if (this.state.documents.length > 0 && this.state.file.agenda.length > 0) {
              this.setState({
                ...this.state,
                videoStyle: { maxWidth: '100%' },
                hasDocsAndAgendas: true,
                docsAgendasDisplay: 'agenda'
              });
            } else if (this.state.documents.length > 0 && this.state.file.agenda.length < 1) {
              this.setState({
                ...this.state,
                videoStyle: { maxWidth: '50%' },
                hasDocsAndAgendas: false,
                docsAgendasDisplay: 'document'
              });
            }
          }
        });      
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }
  setPopup = val => {
    this.setState({popup:val})
  }
  getSchedule = async (liveUrl) => {
    try {
      if(!liveUrl && this.props.video) {
        let res = await axios.post(`${this.props.url}/upload/getLive`, { live: this.props.video});
        liveUrl = res.data.response.payload.live
      }

      /**
       * Assemble Schedule url
       * 
       * IMPORTANT NOTE: client name and channel are in fixed positions within URL.
       *                 If the URL were to change one day, a different approach
       *                 to acquiring client and channel will need to be redone.
       */      
      let scheduleUrl = liveUrl.split("/");
      let client = scheduleUrl[4];
      let channel = scheduleUrl[6];

      let { status, data } = await axios.get(`https://api.castus.tv/ccs/v1/schedule/${client}/${channel}`);
      if(data?.items && status === 200) {
        data = parseSchedule(data);
      }
      let schedule = data.schedule.filter(item => item.item);
      if (this.mounted && schedule.length) {
        this.setState({
          schedule: data.schedule,
          schedule_info: data.report,
          schedule_metadata: data.metadata,
        });
      }
    } catch (err) {
      console.error("Error getting schedule:")
      console.error(err)
    }
  }

  startLive = () => {
    if (this.mounted) {
 
      axios.post(`${this.props.url}/upload/infoLive`, { live: this.props.video })
      .then(res => {
        if(this.mounted) {
          this.setState({
            file: res.data.response.payload.live,
            // liked:
            //   this.props.pub_user &&
            //   res.data.response.payload.live.likes.includes(
            //     this.props.pub_user._id
            //   ),
            // disliked:
            //   this.props.pub_user &&
            //   res.data.response.payload.live.dislikes.includes(
            //     this.props.pub_user._id
            //   ),
            shared: false,
          });

          // Get currently watching
          if(!this.state.schedule.length) {
            this.getSchedule(res.data.response.payload.live.url)
          }
        }
      }, () => {
        console.error("There was an error getting live info.");
        this.startLive();
      });
   
    }
  };

  updateLiveViews = async () => {
    try {
      const { id } = this.state;
      const res = await axios.get(`${VIEWS_URL}live/recent/${id}`);

      if (this.mounted) {
        this.setState({ liveViewCount: parseInt(res.data, 10) });
      }

    } catch(err) {
      console.error(`Error getting live views: ${err}`)
    }

    if (this.mounted) {
      // Don't start polling twice
      if(this.updateLiveViewsTimeout) {
        clearTimeout(this.updateLiveViewsTimeout)
      }
      this.updateLiveViewsTimeout = setTimeout(this.updateLiveViews, 10000)
    }
  }

  parseLive = () => {
    let views = 0;

    if (this.state.liveViewCount) {
      views = this.state.liveViewCount;
    }

    // Fallback for old behavior
    else if (this.state.file && this.state.file.views) {
      views = this.state.file.views.filter(item => {
        if (
          item.end &&
          new Date().getTime() - new Date(item.end).getTime() > 60000
        ) {
          return false;
        } else {
          return true;
        }
      }).length;
    }

    return `${views} watching now`;
  };

  setViews = (force=false, viewData={}, type) => {
    if(!type) {
      type = getQueryVariable("type");
    }

    let now = Date.now();

    if (this.state.watchToken && (now - this.state.lastViewUpdate > 30000 || force)) {
      if (type === "live") {
        axios.post(`${VIEWS_URL}live/view`, {
          file: this.props.video,
          view: {
            user: this.state.watchToken,
            ...viewData
          }
        })
      } else if (this.state.file && this.state.file._id && this.state.watchTime > 0) {
        
        axios.post(`${VIEWS_URL}video/view`, {
          file: { _id: this.state.file._id },
          view: {
            watchTime: this.state.watchTime,
            user:
              this.props.pub_user && this.props.pub_user._id
                ? this.props.pub_user._id
                : this.state.watchToken,
            ...viewData
          }
        })
      } else {
        // Do not set last view update if we did not actually update the view
        return
      }

      // This needs to be inside of this block, otherwise views will not be updated correctly!
      if (this.mounted) {
        this.setState((state) => ({...state, lastViewUpdate: now}))
      }
    }
  }


  componentDidUpdate() {


    const file = this.state.file;
    const { companyEndpoint, viewerObj } = this.context;

    //check if the file metadata has loaded and if the file is apart of a subscription
    const monetizedFile = file.metadata?.associatedSubscriptions;
    if (monetizedFile) {
      // check if the file has any active subscriptions associated with it
      if (Object.keys(monetizedFile).length === 0) return;
      const product_Id = viewerObj?.subscription?.product_Id;
      //verify that the viewer has the correct subscription to view the video
      const activeSub = file.metadata.associatedSubscriptions.hasOwnProperty(product_Id);
      // redirect the viewer if they do not have the correct subscription
      if(!activeSub) {
        return this.setState({ ...this.state, redirect: true })
        // return window.location = `${window.location.origin}/vod/${companyEndpoint}`;
      }
    }

    if (this.props.pub_user && this.state._id !== this.props.pub_user._id) {

      let file = this.state.file;
 
      if (file.downloadBuys && file.downloadBuys.includes(this.props.pub_user._id)) {
        file.downloadPrice = 0;
        this.setState({ file });
      }
      this.setState({ _id: this.props.pub_user._id });
    }

    if (this.state.id !== this.props.video) {
      // if (
      //   this.props.pub_user._id === "" ||
      //   this.state.file.views.some(item => {
      //     return item._id === this.props.pub_user._id;
      //   }) === false
      // ) {
      //   axios
      //     .post(this.props.url + "/upload/setViews", {
      //       file: this.state.file,
      //       view: {
      //         watchTime: this.state.watchTime,
      //         _id: this.props.pub_user._id
      //       }
      //     })
      //     .then(res => {
      //       console.log(res.data);
      //     });
      // }

      this.setState({ id: this.props.video });
      
      axios.post(`${this.props.url}/upload/info`, { file: this.props.video })
      .then(res => {
    
        if (this.mounted) {
          this.setState({
            file: res.data.response.payload.file,
            // liked: res.data.response.payload.file.likes.includes(
            //   this.props.pub_user._id
            // ),
            // disliked: res.data.response.payload.file.dislikes.includes(
            //   this.props.pub_user._id
            // ),
            shared: false
          });
        }
      });
    }
  }

  // handleVideoLikes = () => {
  //   if (this.props.pub_user._id !== "") {
  //     if (this.state.liked) {
  //       axios
  //         .post(
  //           this.props.url +
  //             "/upload/like" +
  //             (getQueryVariable("type")
  //               ? getQueryVariable("type") === "live"
  //                 ? "Live"
  //                 : ""
  //               : ""),
  //           {
  //             file: this.state.file,
  //             user: this.props.pub_user,
  //             action: "pull",
  //           }
  //         )
  //         .then((res) => {
  //           console.log(res.data);
  //         });
  //     } else {
  //       axios
  //         .post(
  //           this.props.url +
  //             "/upload/like" +
  //             (getQueryVariable("type")
  //               ? getQueryVariable("type") === "live"
  //                 ? "Live"
  //                 : ""
  //               : ""),
  //           {
  //             file: this.state.file,
  //             user: this.props.pub_user,
  //             action: "push",
  //           }
  //         )
  //         .then((res) => {
  //           console.log(res.data);
  //         });
  //     }
  //     // if (this.state.disliked) {
  //     //   axios
  //     //     .post(
  //     //       this.props.url +
  //     //         "/upload/dislike" +
  //     //         (getQueryVariable("type")
  //     //           ? getQueryVariable("type") === "live"
  //     //             ? "Live"
  //     //             : ""
  //     //           : ""),
  //     //       {
  //     //         file: this.state.file,
  //     //         user: this.props.pub_user,
  //     //         action: "pull",
  //     //       }
  //     //     )
  //     //     .then((res) => {
  //     //       console.log(res.data);
  //     //     });
  //     // }
  //     this.setState({
  //       liked: !this.state.liked,
  //       // disliked:
  //       //   this.state.disliked && !this.state.liked
  //       //     ? false
  //       //     : this.state.disliked,
  //     });
  //   } else {
  //     this.props.register();
  //   }
  // }

  // handleVideoDislikes = () => {
  //   if (this.props.pub_user._id !== "") {
  //     if (this.state.disliked) {
  //       axios
  //         .post(
  //           this.props.url +
  //             "/upload/dislike" +
  //             (getQueryVariable("type")
  //               ? getQueryVariable("type") === "live"
  //                 ? "Live"
  //                 : ""
  //               : ""),
  //           {
  //             file: this.state.file,
  //             user: this.props.pub_user,
  //             action: "pull",
  //           }
  //         )
  //         .then((res) => {
  //           console.log(res.data);
  //         });
  //     } else {
  //       axios
  //         .post(
  //           this.props.url +
  //             "/upload/dislike" +
  //             (getQueryVariable("type")
  //               ? getQueryVariable("type") === "live"
  //                 ? "Live"
  //                 : ""
  //               : ""),
  //           {
  //             file: this.state.file,
  //             user: this.props.pub_user,
  //             action: "push",
  //           }
  //         )
  //         .then((res) => {
  //           console.log(res.data);
  //         });
  //     }
  //     if (this.state.liked) {
  //       axios
  //         .post(
  //           this.props.url +
  //             "/upload/like" +
  //             (getQueryVariable("type")
  //               ? getQueryVariable("type") === "live"
  //                 ? "Live"
  //                 : ""
  //               : ""),
  //           {
  //             file: this.state.file,
  //             user: this.props.pub_user,
  //             action: "pull",
  //           }
  //         )
  //         .then((res) => {
  //           console.log(res.data);
  //         });
  //     }
  //     this.setState({
  //       disliked: !this.state.disliked,
  //       liked:
  //         this.state.liked && !this.state.disliked
  //           ? false
  //           : this.state.liked,
  //     });
  //   } else {
  //     this.props.register();
  //   }
  // }

  getUrlAndCopy = () => {
    // Query the URL to determine type is live or not
    if (getQueryVariable("type") !== "live") {
      copy(`${this.props.url}/ssr/watch/${this.props.video}`);
    } else {
      copy(`${this.props.url}/ssr/live/${this.props.video}`);
    }
    this.setState({ copied: true });
  }

  downloadVideo = () => {
    
    axios.post(`${this.props.url}/upload/get`, {
      file: this.props.video,
      user: this.props.pub_user ? this.props.pub_user._id : null,
    })
    .then(res => {
      if (res.data.response.success) {
        axios({
          url: res.data.response.payload.data, //your url
          method: "GET",
          responseType: "blob", // important
          onDownloadProgress: (progressEvent) => {
            const totalLength = progressEvent.lengthComputable
              ? progressEvent.total
              : progressEvent.target.getResponseHeader("content-length") ||
                progressEvent.target.getResponseHeader("x-decompressed-content-length");
       
            if (this.mounted && totalLength !== null) {
              this.setState({
                downloadPercentage: (progressEvent.loaded * 100) / totalLength,
              });
            }
          }
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          //or any other extension
          link.setAttribute("download", `${this.state.file.metadata.filename}.mp4`); 
          document.body.appendChild(link);
          link.click();
        });

      }
    });
}

  embedVideo = () => {
    const url = window.location.href.replace("/video/", "/embed/").split("&embedID=")[0];
    let embed = `
        <iframe
          src="${url}&embedID=${this.props.video}"
          title="${this.state.file?.metadata?.filename || "CASTUS Embedded Video Player"}"
          allowtransparency="true"
          frameborder="0"
          width="650"
          height="315"
          sandbox="allow-same-origin allow-forms allow-scripts"
          scrolling="auto"
          allowfullscreen
          style="border:none;border-radius:4px;"
        ></iframe>`;
    copy(embed);
    this.setState({ embedCopy: true });
  }

  //opens modal for the download being bought
  handleCheckoutClick = () => {
    if (this.props.pub_user._id === "") {
      this.props.register();
    } else this.setState({ checkout: true, itemBeingBought: 'download'});
  }

  // opens modal for the video being bought
  setItemBeingBought = () => {
    if (this.props.pub_user._id === "") {
      this.props.register();
    } else this.setState({ checkout: true, itemBeingBought: 'payToView'});
  }

  // change tab display between indexes and documents
  changeTabDisplay = (name) => {
    if (name === 'agenda') {
      this.setState({ 
        ...this.state, 
        videoStyle: { maxWidth: '100%' },
        docsAgendasDisplay: 'agenda'
      });
    } else if (name === 'document') {
      this.setState({
        ...this.state,
        videoStyle: { maxWidth: '50%' },
        docsAgendasDisplay: 'document'
      });
    }
  };

  render() {
    const { ownerOfVODId, companyEndpoint, viewerId, config, darkMode } = this.context;
    if (this.state.redirect) {
      return <Redirect 
              to={{
                pathname: `/${companyEndpoint}/subscriptions`,
                state: { associatedSubscriptions: this.state.file.metadata.associatedSubscriptions }
              }}/>
    }
    let commentsDisabled = this.props.commentsDisabled;

    // Props going to reusable ShareButton component
    let shareVideoButtonProps = {
      color: this.props.color,
      copied: this.state.copied,
      downloadsDisabled: this.props.downloadsDisabled,
      downloadPercentage: this.state.downloadPercentage,
      file: this.state.file,
      checkout: this.state.checkout,
      embedCopy: this.state.embedCopy,
      buttonText: "SHARE",
      onCopyUrlClick: this.getUrlAndCopy,
      onDownloadVideoClick: this.downloadVideo,
      onCheckoutClick: this.handleCheckoutClick,
      onEmbedVideoClick: this.embedVideo,
      copyUrlToolTip: "Copy Video URL",
      downloadVideoToolTip: "Download Video",
      payForVideoToolTip: "Pay to Download Video",
      embedToolTip: "Embed Video",
      embedToolTipPlacement: "top",
    }
  
    let comments = null;

    if (this.state.file.comments && !commentsDisabled) {
      comments = this.state.file.comments
      .filter(item => item.user && item.user.email)
      .sort((a, b) => {
        if (getQueryVariable("type") ? getQueryVariable("type") : "video" === "live") {
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        } else {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        }
      })
      .map(item => {
        return (
          <div key={item._id} className="flex-row mt-3" style={{ position: "relative" }}>
            <div>
              <ProfilePic user={item.user} lg />
            </div>
            <div className="ml-3 comment-body">
              <div className="flex-row" style={{ alignItems: "center" }}>
                <p className="comment-text">
                  {item.user ? item.user.email : ""}
                </p>
                <p className="dt ml-3 bold">{parseText(new Date(item.date))}</p>
              </div>
              {item.text}
            </div>
            <div
              className={
                item.user
                  ? this.props.pub_user &&
                    this.props.pub_user._id === item.user._id
                    ? "delete-comment"
                    : "d-none"
                  : "d-none"
              }
              onClick={() => {
                
                axios.post(
                    VIDEO_UPDATE_URL +
                      (getQueryVariable("type")
                        ? getQueryVariable("type")
                        : "file") +
                      "/" +
                      this.state.file._id +
                      "/remove-comment",
                    {
                      comment: item,
                    }
                  )
                  .then(({ data }) => {
                    if (data.nModified) {
                      
                      axios.get(
                          VIDEO_LOOKUP_URL +
                            (getQueryVariable("type")
                              ? getQueryVariable("type")
                              : "file") +
                            "/" +
                            this.state.file._id +
                            "/comments"
                        )
                        .then(({ data }) => {
                          let file = this.state.file;
                          file.comments = data;
                          if(this.mounted) {
                            this.setState({ file });
                          }
                        });
                    }
                  });
              }}
            >
              <i className="fas fa-times text-danger"></i>
            </div>
          </div>
        );
      });
    }

    return (
      <div className="custom-container-plus mt-3" id="body">


        {/* <Helmet>
          <meta
            name="description"
            content={this.state.file.metadata.description}
          />
          <meta name="title" content={this.state.file.metadata.filename} />
          <meta
            name="og:description"
            content={this.state.file.metadata.description}
          />
          <meta name="og:title" content={this.state.file.metadata.filename} />
          <meta
            name="og:image"
            content={`https://dlttx48mxf9m3.cloudfront.net/outputs/${
              this.props.video
            }/Default/Thumbnails/out_003.png?refresh=${Math.random()}`}
          />
          <meta
            name="twitter:description"
            content={this.state.file.metadata.description}
          />
          <meta
            name="twitter:title"
            content={this.state.file.metadata.filename}
          />
          <meta
            name="twitter:image"
            content={`https://dlttx48mxf9m3.cloudfront.net/outputs/${
              this.props.video
            }/Default/Thumbnails/out_003.png?refresh=${Math.random()}`}
          />
        </Helmet> */}

        <div className="row">
          {/* <div className="col-lg-9 control-document-size" style={ this.state.videoStyle }> */}
          <div className={`col-lg-9 ${this.state.docsAgendasDisplay === 'document' ? 'control-document-size' : ''}`}>
            <div className="video-player-wrapper">
              <div className="video-player">
                <VideoPlayWrapper
                  translations={this.state.file.translations}
                  register={this.props.register}
                  viewerId={viewerId}
                  color={this.props.color}
                  file={this.state.file}
                  url={this.props.url}
                  user={this.props.user}
                  pub_user={this.props.pub_user}
                  setItemBeingBought={this.setItemBeingBought}
                  video={this.props.video}
                  setViews={this.setViews}
                  videoProps={{
                    onTimeUpdate: () => this.setViews(),
                    onPause: () => this.setViews(true),
                    onPlay: () => this.setViews(true)
                  }}
                  update={(time) => {
                    if (this.state.currentTime !== time) {
                      this.setState({ currentTime: time });
                      // console.log(
                      //   Math.abs(time - this.state.file.metadata.duration)
                      // );
                      if (Math.abs(time - this.state.file.metadata.duration) < 1.5) {
                        this.setState({ watchTime: time });
                        setTimeout(() => {
                          this.setState({ playNext: true });
                        }, 5000);
                      } else {
                        this.setState({ watchTime: time, playNext: true });
                      }
                    }
                  }}
                  type={getQueryVariable("type") ? getQueryVariable("type") : "video"}
                  shouldUpdate={this.state.shouldUpdate}
                  clearUpdate={() => this.setState({ shouldUpdate: false })}
                  scrubTo={this.state.scrubTo}
                  shouldPlay={this.state.file.watchPrice > 0 ? false : true}
                  downloadsDisabled={this.props.downloadsDisabled}
                />
              </div>
            </div>
            
            <div
              className="border-bottom flex-row"
              style={{ justifyContent: "space-between" }}
            >
              <div className="mb-3 flex-1">
                <h1 className="display-4 sm">
                  {this.state.file.metadata
                    ? this.state.file.metadata.filename
                    : (this.state.file.name !== "MongoNetworkError" ? this.state.file.name : "")}
                </h1>
                <h1 className={darkMode?"dark dt": "dt"}>
                  {!config.hideViews && !this.state.hideVideoViews && this.state.file.views ? (getQueryVariable("type") === "live"
                    ? this.parseLive(this.state.file.views)
                    : this.state.file.views.length === 1
                    ? `${parseNumbers(this.state.file.views.length)} view .`
                    : `${parseNumbers(this.state.file.views.length)} views .`) : ""}
                  {/* {getQueryVariable("type") !== "live" ? "· " : " "} */}
                  {getQueryVariable("type") !== "live"
                    ? parse(
                        this.state.file.switches &&
                          this.state.file.switches.date.selected ===
                            "original date"
                          ? new Date(this.state.file.original_date)
                          : new Date(this.state.file.date)
                      )
                    : ""}
                  {this.state.file.watchPrice > 0
                    ? `  Watch Price:· $${this.state.file.watchPrice.toFixed(2)}`
                    : ""}
                  {this.state.file.downloadPrice > 0
                    ? ` Download Price· $${this.state.file.downloadPrice.toFixed(2)}`
                    : " "}
                </h1>
                <h1 className={darkMode?"dark dt":"dt"} style={{ whiteSpace: "pre-wrap" }}>
                  {"\n"}
                  {this.state.file.metadata
                    ? this.state.file.metadata.description
                    : ""}
                </h1>
              </div>

              <div
                className="mb-3 social flex-row flex-half"
                style={{
                  justifyContent: "space-evenly",
                  alignItems: "flex-end",
                }}
              >
                <>
                  {/* <div
                    className={
                      "social-item " +
                      (this.state.liked ? "" : "text-secondary mr-2")
                    }
                    style={{
                      color: this.state.liked ? this.props.color : "",
                    }}
                    data-tip
                    data-for="videoLikes"
                  > */}
                    {/* Like Icon Starts */}
                    {/* <i
                      className={
                        "fas fa-thumbs-up " +
                        (this.state.liked ? "" : "text-secondary mr-2")
                      }
                      style={{
                        color: this.state.liked ? this.props.color : "",
                      }}
                      onClick={this.handleVideoLikes}
                    ></i> */}
                    {/* Like Icon Ends */}
                    {/* Like Count Start */}
                      {/* {parseNumbers(
                        this.state.file.likes.length + (this.state.liked | 0)
                        )} */}
                    {/* Like Count Ends */}
                  {/* </div>
                  <ReactTooltip id="videoLikes" type="dark" effect="solid">
                    <span>I like this</span>
                  </ReactTooltip> */}
                </>
                
                {/* Commenting out dislikes function until we get a client toggle like feature */}
                {/* <>
                  <div
                    className={
                      "social-item " +
                      (this.state.disliked ? "" : "text-secondary mr-2")
                    }
                    style={{
                      color: this.state.disliked ? this.props.color : "",
                    }}
                    data-tip
                    data-for="videoDislikes"
                  >
                    <i
                      className={
                        "fas fa-thumbs-up rotate " +
                        (this.state.disliked ? "" : "text-secondary mr-2")
                      }
                      style={{
                        color: this.state.liked ? this.props.color : "",
                      }}
                      onClick={this.handleVideoDislikes}
                    ></i>
                    {parseNumbers(
                      this.state.file.dislikes.length +
                        (this.state.disliked | 0)
                    )}
                  </div>
                  <ReactTooltip id="videoDislikes" type="dark" effect="solid">
                    <span>I dislike this</span>
                  </ReactTooltip>
                </> */}

                {/* Share Button */}
                <ShareButton translations={this.state.file.translations} setPopup={this.setPopup}  setItemBeingBought={this.setItemBeingBought} {...shareVideoButtonProps} />
              </div>
            </div>

            {
              <Schedule
                visible={
                  getQueryVariable("type") === "live" &&
                  this.state.schedule.length
                }
                schedule={this.state.schedule}
                schedule_info={this.state.schedule_info}
                schedule_metadata={this.state.schedule_metadata}
                color={this.props.color}
                setFile={(file) => {
                  this.props.setFile(file);
                }}
                webScheduleLive={this.props.webScheduleLive}
                webSchedulePrimary={this.props.webSchedulePrimary}
                webScheduleSecondary={this.props.webScheduleSecondary}
                webScheduleAvailable={this.props.webScheduleAvailable}
              />
            }
            {commentsDisabled ? null :
            (<div>
              <div
                style={{
                  display:
                    (this.props.pub_user && this.props.pub_user._id === "") ||
                    (this.state.file &&
                      this.state.file.switches &&
                      this.state.file.switches.comments.selected === "disabled")
                      ? "none"
                      : "",
                }}
              >
                <Comment
                  pub_user={this.props.pub_user}
                  url={this.props.url}
                  video={this.state.file}
                  add={(e) => {
                    let file = this.state.file;
                    let comments = file.comments;
                    comments.push({
                      user: {
                        _id: this.props.pub_user._id,
                        email: this.props.pub_user.email,
                      },
                      text: e,
                      date: new Date(),
                    });
                    file = { ...file, comments };

                    this.setState({ file });
                    axios
                      .get(
                        VIDEO_LOOKUP_URL +
                          (getQueryVariable("type")
                            ? getQueryVariable("type")
                            : "file") +
                          "/" +
                          this.state.file._id +
                          "/comments"
                      )
                      .then(({ data }) => {
                        let file = this.state.file;
                        file.comments = data;
                        if(this.mounted) {
                          this.setState({ file });
                        }
                      });
                  }}
                  type={getQueryVariable("type") ? getQueryVariable("type") : "video"}
                  color={this.props.color}
                />
              </div>

              {comments}
            </div>)
          }
          </div>

          <div className="col-lg-3">
          {this.state.checkout && <Checkout
              url={this.props.url}
              user={this.props.user}
              visible={this.state.checkout}
              pub_user={this.props.pub_user}
              item={this.state.file}
              viewerId={viewerId}
              companyEndpoint={companyEndpoint}
              ownerOfVODId={ownerOfVODId}
              itemBeingBought={this.state.itemBeingBought}
              close={() => {this.setState({ checkout: false })}}/>}
            {/* Display document if it exists */}

            {this.state.documents.length > 0 ? 
              <Document
                documents = {this.state.documents ? this.state.documents: []} 
                tabDisplay={this.state.docsAgendasDisplay}
                hasAgenda={this.state.hasDocsAndAgendas}
                changeDisplay={this.changeTabDisplay}
              /> : null}

            {this.state.docsAgendasDisplay === 'agenda' ?
              <Agenda 
                video={this.props.video}
                items={this.state.file.agenda ? this.state.file.agenda : []}
                scrubTo={ (time) => this.setState({ shouldUpdate: true, scrubTo: time }) } 
                curentTime={this.state.currentTime}
                color={this.props.color}
                file={this.state.file._id}
                url={this.props.url}
              /> : null}

            <RecommendedVideosList
              videoId={this.props.video}
              color={this.props.color}
              url={this.props.url}
              user={this.props.user}
              setFile={(file) => {
                this.setState({ watchTime: 0 });
                this.props.setFile(file);
              }}
              recommendationList={this.props.recomended}
              type={ getQueryVariable("type") ? getQueryVariable("type") : "video"}
              // finished={this.state.playNext}
              // togglePlayNext={val => {
              //   this.setState({ playNext: val });
              // }}
            />
            {/* <Recomended
              video={this.props.video}
              color={this.props.color}
              url={this.props.url}
              user={this.props.user}
              setFile={(file) => {
                this.setState({ watchTime: 0 });
                this.props.setFile(file);
              }}
              recomended={this.props.recomended}
              type={ getQueryVariable("type") ? getQueryVariable("type") : "video"}
              // finished={this.state.playNext}
              // togglePlayNext={val => {
              //   this.setState({ playNext: val });
              // }}
            /> */}
          </div>
        </div>
        {this.state.popup?<SelectOption file={this.state.file} translations={this.state.file.translations} setPopup={this.setPopup}/>:''}
      </div>
    );
  }
}

export default VideoScreen;
